<template>
  <div class="main-layout">
    <navbar />
    <div class="container side">
      <sidebar />
    </div>
    <div class="container bottom">
      <bottomside />
    </div>
    <div class="container mt-3 main-content">
      <child />
    </div>
    <div class="container tour-modal">
      <Modal />
    </div>
    <Websocket hidden />
  </div>
</template>

<script>
import Navbar from '~/components/PcsNavbar'
import sidebar from '~/components/Sidebar'
import bottomside from '~/components/BottomSide'
import Modal from '~/components/modal'
import Websocket from '../components/Websocket'

export default {
  name: 'MainLayout',

  components: {
    Websocket,
    Navbar,
    sidebar,
    bottomside,
    Modal
  },

  created: function () {
    localStorage.setItem('path', 'forensics')
  }
}
</script>

<style scoped lang="scss">
  .basic-layout {
    color: #636b6f;
    height: 100vh;
    font-weight: 100;
    position: relative;

    .links > a {
      color: white;
      padding: 0 25px;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: .1rem;
      text-decoration: none;
      text-transform: uppercase;
    }
  }
  .side {
    position: absolute;
    top: 60px;
    left: 4px;
    width: 280px;
    bottom : 300px;
    border-style: solid;
    border-width: 2px;
  }

  .main-content {
    position: absolute;
    top: 44px;
    bottom: 4px;
    right: 4px;
    left: 288px;
    width: inherit;
    border-style: solid;
    border-width: 2px;
    overflow-y: auto;
    max-width: 100%;
  }

  .bottom {
    position: absolute;
    bottom: 4px;
    left: 4px;
    width: 280px;
    height : 292px;
    border-style: solid;
    border-width: 2px;
  }
  .tour-modal {
    min-height: 100%;
    min-width: 100%;
    z-index: 100;
  }
</style>
